import React from 'react'
import { IStory } from '../../store'

export const StoriesContext = React.createContext({
  stories: undefined as IStory[] | undefined
})
export const StoryContext = React.createContext(undefined as IStory | undefined)
